(function paycheckModuleDefinition() {
    'use strict';

    angular.module('Paycheck', ['ngFileUpload', 'ui.router', 'Config', 'Entities', 'CustomControls', 'ui.select', 'ui.selectExtend', 'TranslatedPaginator'
        , 'ClickOnce', 'FileDownloader', 'DoublyLinkedList', 'DocumentViewer', 'SignNacionControl'
    ])
        .config([
            'configProvider', '$stateProvider', 'loginProvider',
            function paycheckConfig(config, $stateProvider, loginProvider) {

                $stateProvider.state('paycheck-sign', {
                    url: "/Paycheck/Sign",
                    templateUrl: config.resourceUrl('/views/paycheck/paycheck-sign.html'),
                    controller: 'PaycheckSignController',
                    authorize: true,
                    roles: loginProvider.roleCondition('PAYCHECKCUSTOMER SIGN')
                });

                $stateProvider.state('paycheck-find', {
                    url: "/Paycheck/Find",
                    templateUrl: config.resourceUrl('/views/paycheck/paycheck-find.html'),
                    controller: 'PaycheckFindController',
                    authorize: true,
                    roles: loginProvider.roleCondition('PAYCHECKCUSTOMER READ')
                });

                $stateProvider.state('paycheck-find-pending', {
                    url: "/Paycheck/Find/SignPending",
                    templateUrl: config.resourceUrl('/views/paycheck/paycheck-find.html'),
                    controller: 'PaycheckFindController',
                    authorize: true,
                    roles: loginProvider.roleCondition('PAYCHECKCUSTOMER READ'),
                    params: { isSignPending: true }
                });

                $stateProvider.state('paycheck-detail', {
                    url: "/Paycheck/Detail/{id}",
                    templateUrl: config.resourceUrl('/views/paycheck/paycheck-detail.html'),
                    controller: 'PaycheckDetailController',
                    authorize: true,
                    roles: loginProvider.roleCondition('PAYCHECKCUSTOMER READ')
                });

                $stateProvider.state('paycheck-edit', {
                    url: "/Paycheck/Edit/{id}",
                    templateUrl: config.resourceUrl('/views/paycheck/paycheck-edit.html'),
                    controller: 'PaycheckEditController',
                    authorize: true,
                    roles: loginProvider.roleCondition('PAYCHECKCUSTOMER READ').and('PAYCHECKCUSTOMER SIGN')
                });
            }
        ]);
})();
